import React, { useState } from 'react';
import _ from 'lodash';

import { Button, Dialog, OverlayTrigger, PopOver, Switch } from '@tencent/spaui';

import useInput from '../../hooks/useInput';
import useList from '../../hooks/useList';
import useSelect from '../../hooks/useSelect';
import useSwitch from '../../hooks/useSwitch';
import RequiredInput from '../../common/RequiredInput';

import APIInput from './components/api';
import Field from './components/formField';
import StandardField from './components/standardField';

import { DimensionMap, FIELD, STATUS } from './config';

import { RPCFactory } from '../../../utils/RequestUtil';

import { arrayToObject, listToStr, objectToArray } from './helper';
import LeadsPushDataFormat from '../../../consts/LeadsPushDataFormat';
import PrivilegeCode from '../../../consts/PrivilegeCode';
import RuleApplyRange from '../../common/RuleApplyRange';
import useRuleApplyRange from '../../hooks/useRuleApplyRange';

const DimensionData = [];

_.forEach(DimensionMap, (e, key) => {
  DimensionData.push({
    label: e,
    value: key,
  });
});

const fieldInitData = [];

const notAutoSelectedItems = new Set([
  'leads_pool_id',
  'layer_form_content',
  'nick_name',
  'is_broad_cast_leads',
  'custom_qa', // add by fightingliu 二期
  'owner_name',
  'all_follow_records'
]);
_.forEach(FIELD, (e, key) => {
  if (notAutoSelectedItems.has(key)) return;
  fieldInitData.push({
    key,
    value: key,
  });
});

const settingDialog = (props) => {
  const genFieldList = (key) => {
    if (props.model == 'copy' || props.model == 'edit') {
      return objectToArray(props.editItem[key]);
    }
    if (key == 'standardFieldMap') {
      return fieldInitData;
    }
    return [{ key: '', value: '' }, { key: '', value: '' }];
  };

  const getInitRuleName = () => {
    if (props.model == 'add') {
      return '';
    }
    if (props.editItem) {
      if (props.model == 'edit') {
        return props.editItem.ruleName || '';
      }
      if (props.model == 'copy') {
        return `${props.editItem.ruleName}（复制）` || '';
      }
      return '';
    }
  };
  const { model = 'add', editItem = {} } = props || {};

  const { applyRange = {} } = editItem;

  const isLast = model == 'edit' && editItem.isLast;
  const [apiStatus, setApiStatus] = useState(STATUS.INIT);
  const ruleNameHooks = useInput({
    value: getInitRuleName(),
    required: true,
  });

  const applyRangeHooks = useRuleApplyRange({
    data: applyRange,
    model,
  });

  const leadsPushUrlHooks = useInput({
    data: props.editItem,
    key: 'leadsPushUrl',
    required: true,
    onChange: () => {
      setApiStatus(STATUS.INIT);
    },
  });

  const appTokenHooks = useInput({
    data: props.editItem,
    key: 'appToken',
  });

  const appSecretHooks = useInput({
    data: props.editItem,
    key: 'appSecret',
  });

  const bundleFieldHooks = useList({
    data: genFieldList('bundleFieldMap'),
    emptyItem: { key: '', value: '' },
  });

  // 设置互动内容字段 by fighting
  const customQaFieldHooks = useList({
    data: genFieldList('customQaFieldMap'),
    emptyItem: { key: '', value: '' },
  });

  const constFieldHooks = useList({
    data: genFieldList('constFieldMap'),
    emptyItem: { key: '', value: '' },
  });

  const standardFieldHooks = useList({
    data: genFieldList('standardFieldMap'),
    emptyItem: { key: '', value: '' },
  });

  const pushDataFormatHooks = useSwitch({
    checked:
      props.model == 'edit' || props.model == 'copy'
        ? props.editItem.pushDataFormat == LeadsPushDataFormat.TEMPLATE.getCode()
        : false,
  });

  const [pushTemplate, setPushTemplate] = useState(
    props.model == 'edit' || props.model == 'copy' ? props.editItem.pushTemplate : null,
  );

  const dimensionHooks = useSelect({
    data: DimensionData,
    value: props.model == 'edit' || props.model == 'copy' ? props.editItem.dimension : 'ALL',
  });

  const [value, setValue] = useState(
    props.model == 'edit' || props.model == 'copy' ? listToStr(props.editItem.dimensionValues) : null,
  );

  const testUrl = (value) => {
    setApiStatus(STATUS.PENDING);
    RPCFactory.leadsPushRule
      .testUrl({
        leadsPushUrl: value,
      })
      .done(() => {
        setApiStatus(STATUS.SUCCESS);
      })
      .fail(() => {
        setApiStatus(STATUS.FAIL);
      });
  };

  const checkData = () => {
    // 一次性全检测，以免用户反复提交
    const name = ruleNameHooks.checkValid();
    const url = leadsPushUrlHooks.checkValid();

    return name && url;
  };
  const handleSubmit = () => {
    if (!checkData()) {
      props.onInVaild('请先完整填写配置');
    }
    if (!applyRangeHooks.checkValid()) {
      return;
    }
    const postData = {
      ruleName: ruleNameHooks.value,
      leadsPushUrl: leadsPushUrlHooks.value,
      appToken: appTokenHooks.value,
      appSecret: appSecretHooks.value,
      bundleFieldMap: arrayToObject(bundleFieldHooks.dataList),
      customQaFieldMap: arrayToObject(customQaFieldHooks.dataList),
      standardFieldMap: arrayToObject(standardFieldHooks.dataList),
      constFieldMap: arrayToObject(constFieldHooks.dataList),
      applyRange: isLast ? { applyRangeType: 'ELSE' } : applyRangeHooks.applyRange,
      pushDataFormat:
        pushDataFormatHooks.checked != true
          ? LeadsPushDataFormat.DEFAULT.getCode()
          : LeadsPushDataFormat.TEMPLATE.getCode(),
      pushTemplate: pushDataFormatHooks.checked == true ? pushTemplate : '',
    };

    if (props.isEdit()) {
      postData.ruleId = props.editItem.ruleId;
    }
    props.onSubmit(postData);
  };

  const genPlaceholder = () => {
    let label = DimensionMap[dimensionHooks.value];
    label = label ? label : '推广计划ID';
    return `请输入${label}，用英文逗号分隔，如：120323,2321001`;
  };
  return (
    <Dialog
      backdrop
      hideFooter
      type="normal"
      show={props.show}
      className="modal-set-height customrule-dialog"
      onClose={props.onClose}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
      title={props.model == 'edit' ? `${props.editItem.ruleName}接口配置` : '新建接口配置'}
      style={{
        width: '1000px',
      }}
    >
      <div className="interface-setting form-list-normal">
        <div className="lump">
          <div className="lump-hd">基础信息</div>
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <span className="info-tt">规则名称(必填)</span>
                <div className="info-des">
                  <RequiredInput placeholder="请输入规则名称" {...ruleNameHooks}></RequiredInput>
                </div>
              </li>
            </ul>
          </div>
          <div className="lump-hd">服务设置</div>
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <APIInput {...leadsPushUrlHooks} status={apiStatus} doTest={testUrl} />
              </li>
              <li className="infolist">
                <span className="info-tt">密钥</span>
                <div className="info-des">
                  <RequiredInput placeholder="请输入回调密钥" {...appSecretHooks}></RequiredInput>
                </div>
              </li>
              <li className="infolist">
                <span className="info-tt">TOKEN</span>
                <div className="info-des">
                  <RequiredInput placeholder="请输入回调TOKEN" {...appTokenHooks}></RequiredInput>
                </div>
              </li>
            </ul>
          </div>
          <div className="lump-hd">映射关系设置</div>
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <StandardField
                  {...standardFieldHooks}
                  title={'标准字段'}
                  keyLabel={'原始字段名'}
                  valueLabel={'转换后字段名'}
                />
              </li>
              <li className="infolist">
                <Field {...bundleFieldHooks} title={'表单字段'} keyLabel={'原始字段名'} valueLabel={'转换后字段名'} />
              </li>
              <li className="infolist">
                <Field {...customQaFieldHooks} title={'互动内容字段'} keyLabel={'原始字段名'} valueLabel={'转换后字段名'} />
              </li>
            </ul>
          </div>
          <div className="lump-hd">自定义字段设置</div>
          <div className="lump-bd">
            <ul className="infos">
              <li className="infolist">
                <Field {...constFieldHooks} title={'自定义字段'} keyLabel={'字段名'} valueLabel={'字段值'} />
              </li>
            </ul>
          </div>
          {window.pageProps.privilegesInWhite.includes(PrivilegeCode.LEADS_PUSH_RULE_TEMPLATE.getCode()) && (
            <div>
              <div className="lump-hd">
                模板设置
                <OverlayTrigger
                  trigger="hover"
                  alignment="left"
                  overlay={
                    <PopOver style={{ maxWidth: '600px' }}>
                      该功能开启后，线索推送时将不再使用默认的数据推送格式，而是使用规则中设置的模板内容进行替换。
                      <br />
                      <p className="txt">
                        注意：
                        <br />
                        &emsp;推送时会将模板中的$&#123;XXX}用真实数据替换，XXX要使用上方映射关系设置中的转换后字段名/自定义字段的字段名。
                        <br />
                        例：
                        <br />
                        &emsp;原始线索：&#123;"account_id":12345,"leads_id":1234,"leads_name":"张三",...}
                        <br />
                        &emsp;模板内容：&#123;"account_id":$&#123;account_id},"leads":[&#123;"id":$&#123;leads_id},"name":"$&#123;leads_name}",...}]}
                        <br />
                        &emsp;推送数据：&#123;"account_id":12345,"leads":[&#123;"id":123,"name":"张三",...}]}
                      </p>
                    </PopOver>
                  }
                >
                  <i className="spaui-icon icon-help"></i>
                </OverlayTrigger>
                <Switch {...pushDataFormatHooks} />
              </div>
              {pushDataFormatHooks.checked == true && (
                <div className="lump-bd">
                  <ul className="infos">
                    <li className="infolist">
                      <span className="info-tt">模板内容</span>
                      <div className="info-des change-module">
                        <textarea
                          className="spaui-input"
                          rows="10"
                          onChange={(e) => {
                            setPushTemplate(e.target.value);
                          }}
                          placeholder="请输入模板内容"
                        >
                          {pushTemplate}
                        </textarea>
                      </div>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
          <div className="lump-hd">适用范围设置</div>
          <div className="config-li">
            <div className="form-in">
              <RuleApplyRange {...applyRangeHooks} disabled={isLast} />
            </div>
          </div>
          {/* <div className="lump-bd">
                        <ul className="infos">
                            <li className="infolist">
                                <span className="info-tt">适用范围</span>
                                <div className="info-des">
                                    <Select placeholder="请选择" {...dimensionHooks}/>
                                    {
                                        dimensionHooks.value == 'ALL' ? null :
                                        <textarea
                                            className="spaui-input"
                                            rows="10"
                                            onChange={(e) => {setValue(e.target.value)}}
                                            placeholder={genPlaceholder()}
                                        >{value}
                                        </textarea>
                                    }
                                </div>
                            </li>
                        </ul>
                    </div> */}
        </div>
        <div className="btnline">
          <Button displayType="default" onClick={props.onCancel}>
            取消
          </Button>
          <Button displayType="primary" onClick={handleSubmit}>
            确定
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default settingDialog;
